import { lazy } from 'react';

const DailyCollectionReport = lazy(() =>
  import('../pages/DailyCollectionReport/index'),
);

const dailyCollectionReportRoute = {
  public: [],
  auth: [
    {
      name: 'daily_collection_report',
      path: '/treasury/daily-collection-report',
      component: DailyCollectionReport,
    },
  ],
};

export default dailyCollectionReportRoute;
